// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1sbIC","filesListContainer":"PosDisputesFiles_filesListContainer__DVASw","filesButton":"PosDisputesFiles_filesButton__2pDYL"};